// extracted by mini-css-extract-plugin
export default {"container":"NotificationToggle_container__YNICp","btn":"NotificationToggle_btn__6MAdV","badge":"NotificationToggle_badge__AMcg1","list":"NotificationToggle_list__nhFeO"};